export class Specialist {
    id = null;
    name = null;
    code = null;
    description = null;
    isDuplicate = null;
    dupName = null;
    dupCode = null;
}